import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("pricemanage/index"),
  
  store: (userData) => clientAuth.post('pricemanage/store', { json: userData }),
  

  show:(id)=>clientAuth.get('pricemanage/show/'+id),

  update:(id,userData)=>clientAuth.post('pricemanage/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`pricemanage/destroy/${id}`),
};